<template>
  <v-container fluid> 
      <template>

<!-- main table -->
  <v-data-table   
    :headers="headers"
    :search="search"
    :items="contructors"   
     class="elevation-0 my_btn bg-main"
    :footer-props="{
          'items-per-page-text':'عدد العناصر',
            'next-icon':'$prev',
            'prev-icon':'$next', 
          }"
  >
    <template v-slot:top>
      <v-toolbar
        flat class="bg-main"
      >
      <!-- header -->
        <v-toolbar-title >المتعهدين</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <!-- search -->
         <v-text-field
            v-model="search"
            rounded
            class="my_btn"
            append-icon="mdi-magnify"
            label="بحث"
            single-line
            hide-details 
        ></v-text-field>
         <v-spacer></v-spacer>
        <!-- add and delete dialog -->
        <v-dialog 
          v-model="dialog"
          max-width="700px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary" 
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              @click="checkPermissions('card-add')"
            >أضافة<v-icon>mdi-plus</v-icon>  
            </v-btn> 
            <!-- print btn
            <v-btn 
              class="mb-2 mx-2" 
              @click="print()"
            >  <v-icon >mdi-printer-outline</v-icon>
            </v-btn> -->
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>
            <!-- dialog add and edit  -->
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      :rules="rules.name"
                      required
                      label="الاسم"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.address"
                      :rules="rules.address"
                      required
                      label="العنوان"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.phone"
                      :rules="rules.phone" 
                      required
                      label="رقم الهاتف"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.national_id"
                      label="رقم الهوية"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-select
                      v-model="editedItem.contractor_type_change" 
                      :items="contructorTypes"
                      item-text="name"
                      item-value="id"
                      label="نوع المتعهد" 
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="close" > إلغاء </v-btn>
              <v-btn color="green"    :disabled="!formIsValid"  type="submit"  @click="save" > حفظ </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog  v-model="dialogDelete" max-width="500px">
          <v-card>
            <!-- delete dialog -->
            <v-card-title text class="text-h6">هل تريد حذف العنصر بشكل نهائي</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeDelete">الغاء</v-btn>
              <v-btn color="green darken-1" text @click="deleteItemConfirm">موافق</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- details dialog -->
        <v-dialog  v-model="dialogDetails" max-width="500px">
          <v-card class="text-center">
            <v-card-title text  >تفاصيل المتعهد</v-card-title>
            <v-card-text> 

              <img  class=" my-3" width="100px" height="100px"  :src="api+editedItem.image" alt="لايوجد صورة">
              <br> 
              <v-btn icon @click="deletePersonImage(editedItem.id)" color="error"><v-icon>mdi-delete</v-icon></v-btn>
              <v-btn icon @click="uploadImage()" color="success"><v-icon>mdi-upload</v-icon></v-btn>
               
              <hr>

              <div  class=" mt-3" >الاسم:  <b>{{editedItem.name}}</b></div>
              <div>العنوان: <b>{{editedItem.address}}</b></div>
              <div>رقم الهوية: <b>{{editedItem.national_id}}</b></div>
              <div>الهاتف: <b>{{editedItem.phone}}</b></div>
              <div>الملاحظات: <b>{{editedItem.notes}}</b></div> 
              <hr>
              <div  class=" my-3" >المستندات:<v-btn x-small dark color="green"   @click="uploadDoc()">اضافة<v-icon>mdi-plus</v-icon></v-btn> 
              
               <div class="" v-for="item,i in editedItem.documents" :key="i">
               <b> {{i+1}} - {{item.title}}  <v-btn small icon color="red" @click="deleteDoc(item.id)" ><v-icon >mdi-delete</v-icon></v-btn> 
                                            <v-btn small icon color="success" :href="api+item.file" ><v-icon  color="success">mdi-download</v-icon></v-btn> 
               </b> 
               </div>
              </div>
              <!-- <div>النوع: <b>{{editedItem.contractor_type.name}}</b></div> -->
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer> 
              <v-btn color="red darken-1" text @click="close">إغلاق</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- actions of table -->
    <template  v-slot:[`item.operation`]="{item}" >
      <v-icon color="" class="mr-2" @click="editItem(item)" > mdi-pencil </v-icon>
      <v-icon color="red" @click="deleteItem(item)" > mdi-delete </v-icon>
      <v-icon color="blue"  @click="details(item)" > mdi-format-list-text </v-icon> 
    </template>
    <template v-slot:no-data>
      <v-card
      loading
      ><v-btn > انتظر..... </v-btn>
      </v-card>
    </template>
  </v-data-table>
 </template>

 <!-- to print -->
 <v-dialog v-model="dialogPrint">
   <div  >
    <v-data-table
     id="table"
     outline
    :headers="headersPrint"
    :search="search"
    :items="contructors"   
     class="elevation-1" 
     hide-default-footer
     disable-pagination 
    ></v-data-table>
  </div>
 </v-dialog>
 <!-- uploud file dialog -->
 <v-dialog
   v-model="dialogUpload" 
   max-width="500px"
   transition="dialog-transition"
 >
   <v-card>
     <v-card-title primary-title>
       قم بأختير الملف
     </v-card-title>
     <v-card-text> 
       <v-text-field 
         v-if="uploadType=='file'"
         label="اسم الملف"
         v-model="titleFile"
       ></v-text-field>
       <v-file-input @change="uploadFile($event)"></v-file-input>

     </v-card-text>
     <v-card-actions>
       <v-spacer></v-spacer> 
       <v-btn dark text color="red" @click="dialogUpload=false">الغاء</v-btn>
       <v-btn text color="success" @click="saveUploadFile()">حفظ</v-btn>
       <v-spacer></v-spacer> 
     </v-card-actions>
   
   </v-card>
 </v-dialog>


  
</v-container>

</template>
<script>
import tools from '@/plugins/tools'
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex' 
  export default {
    name:'contructorsCard',
    data: () => ({
      formData:new FormData,
      titleFile:'',
      api:'', 
      dialog: false,
      dialogDelete: false,
      dialogDetails:false,
      dialogPrint:false,
      dialogUpload:false,
      uploadType:'', 
      search:'', 
      rules: {
          phone: [val => val.length > 11 || `يجب ان يكون رقم الهاتف مكون من 11 رقم على الاقل`],
          name: [val => (val || '').length > 0 || 'ادخل الاسم '], 
          address: [val => (val || '').length > 0 || 'ادخل العنوان '], 
        },
      headers: [
        { text: 'الاسم',value: 'name',align:'start',sortable: false,},
        { text: 'العنوان ', value: 'address', sortable: false },
        { text: 'الهاتف', value: 'phone' },
        { text: 'رقم الهوية', value: 'national_id' },
        { text: 'النوع', value: 'contractor.contractor_type.name' },
        { text: 'العمليات', value: 'operation', sortable: false },
      ],
      headersPrint: [
        { text: 'الاسم',value: 'name',sortable: false },
        { text: 'العنوان ', value: 'address',sortable: false },
        { text: 'الهاتف', value: 'phone',sortable: false },
        { text: 'رقم الهوية', value: 'national_id' },
        { text: 'النوع', value: 'contractor.contractor_type.name',sortable: false }, 
      ], 
      editedIndex: -1,
      editedItem: {
        name: '',
        address: '',
        phone: '',
        nots: '',
        documents: null,
        contractor_type:{
          name:''
          },
        contractor_type_id: '', 
      },
      defaultItem: {
        name: '',
        address: '',
        phone: '',
        contractor_type_id: '', 
      },
    }),

    computed: {
      ...mapGetters(['contructors','contructorTypes']),
      formTitle () {
        return this.editedIndex === -1 ? 'أضافة جديد' : 'تعديل'
      },
      formIsValid () {
        return (
          Boolean(this.editedItem.name ) &&
          Boolean(this.editedItem.address) &&
          Boolean(this.editedItem.contractor_type_change)  &&
          Boolean(this.editedItem.phone.length>=11) 
        )
        }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () { 
      function url(){
        let a= axios.defaults.baseURL.toString()
          return  a.slice(0,-3)+"/uploads/"
      }
      this.api=url();

      this.f_constructor()
      this.f_constructorTypes()
    }, 
    

    methods: {
      ...mapActions(['f_constructor','deletePersonImage','uploadPersonImage','f_constructorTypes',
                      'uploadPersonDoc','deleteCard','addCard','updateCard','deleteDoc']),

      checkPermissions(per){tools.checkPermissions(per)},


 
      uploadDoc(){//@click
        this.dialogUpload=true
        this.uploadType='file'
      },
      uploadImage(){//@click
        this.dialogUpload=true
        this.uploadType='image'
      },
      uploadFile(f){ 
        this.formData.append(this.uploadType,f) 
      },
       saveUploadFile(){
        if(this.uploadType=='file'){
          this.formData.append('person_id',this.editedItem.id)
          this.formData.append('title',this.titleFile)
          this.uploadPersonDoc(this.formData)  
          this.titleFile='' 
        }
        if(this.uploadType=='image'){
          this.formData.append('id',this.editedItem.id)
          this.uploadPersonImage(this.formData)   

        }
 
        this.dialogUpload=false;
        this.dialogDetails=false;
       },
        
      editItem (item) {
        this.checkPermissions('card-update')
        this.editedIndex = this.contructors.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.contractor_type_change= this.editedItem.contractor.contractor_type.id
        this.dialog = true
      },

      deleteItem (item) {
        this.checkPermissions('card-delete')
        this.editedIndex = this.contructors.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      details(item){
        this.editedIndex = this.contructors.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDetails = true 
      },

      deleteItemConfirm () {
        let card=[]; card.type="constructor"
        card.id=this.contructors[this.editedIndex].contractor.id
        this.deleteCard(card)
        // this.contructors.splice(this.editedIndex, 1)
        this.closeDelete()  
      },

      close () {
        this.dialog = false
        this.dialogDetails = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {//save dialog add and edit
        if (this.editedIndex > -1) { 
          //update item 
          let paramsToUpdate={}
          paramsToUpdate.address= this.editedItem.address
          paramsToUpdate.phone= this.editedItem.phone
          paramsToUpdate.name= this.editedItem.name 
          paramsToUpdate.contractor_type_id= this.editedItem.contractor_type_change
          paramsToUpdate.national_id= this.editedItem.national_id
          paramsToUpdate.person_type_id=2 
          
          let card=[];card.type='constructor'
          card.id=this.contructors[this.editedIndex].contractor.id
          card.data=paramsToUpdate;
 
          this.updateCard(card) 

        } else {
          //add new item 
          this.editedItem.person_type_id=2
          this.editedItem.contractor_type_id=this.editedItem.contractor_type_change

          let card=[];card.type='constructor' 
          card.data=this.editedItem;
 
          this.addCard(card)  
          // this.contructors.push(this.editedItem)
        }
        this.close()
      },

    }, 
  }
</script>
